module.exports = __webpack_public_path__ + "static/media/choithramsRecipeTime.4f96822e.png";